import React, { useState, useEffect } from "react";
import authStorage from "../../utils/authStorage";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import moment from "moment";

const PaymentConfirmationPage = ({ data ,back}) => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [currentDay, setSelectedDay] = useState('');
    const [selectedFullDate, setSelectedFullDate] = useState('');
    const [selectedSlots, setSelectedSlots] = useState('');
    const [bookedSlots, setBookedSlots] = useState([]);
    const [availavleSlots, setAvailavleSlots] = useState([]);
    const [paymentDetail, setPaymentDetail] = useState();
    const [error, setError] = useState('');
    const [amoun, setAmoun] = useState();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const[receiptGloUrl,setReceiptGloUrl]=useState();
    const[invoiceDownloadUrl,setInvoiceDownloadUrl]=useState();
    const daysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const getMonthName = (month) => {
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        return monthNames[month - 1];
    };

    const monthDays = daysInMonth(currentMonth, currentYear);
    const firstDay = new Date(currentYear, currentMonth - 1, 1).getDay();
    const weeks = Math.ceil((monthDays + firstDay) / 7);

    const days = [];
    for (let i = 1; i <= weeks * 7; i++) {
        if (i > firstDay && i <= monthDays + firstDay) {
            days.push(i - firstDay);
        } else {
            days.push(null);
        }
    }

    const handlePreviousMonth = () => {
        if (currentMonth === 1) {
            setCurrentMonth(12);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
    };

    const handleNextMonth = () => {
        if (currentMonth === 12) {
            setCurrentMonth(1);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
    };

    const handlePreviousYear = () => {
        setCurrentYear(currentYear - 1);
    };

    const handleNextYear = () => {
        setCurrentYear(currentYear + 1);
    };

    const createTrainningSession = () => {
		let striptMode = authStorage.getItem("striptMode");
		
		console.log('striptMode: ', striptMode);
		
        if (data.redirectStatus !== 'succeeded') {
            return;
        }
        setLoading(true);
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/create/training/session`, 
            method: 'post',
            data: { paymentIntent: data.paymentIntent, striptMode: striptMode }
        }).then((res) => {
            console.log("recept url : ",res?.data);
            authStorage.setItem("payData",JSON.stringify(res?.data))
            setPaymentDetail(res?.data?.data);
            setReceiptGloUrl(res?.data?.receiptUrl);setInvoiceDownloadUrl(res?.data?.invoiceDownloadUrl)
            setLoading(false);
        });
    };

    const confirmTrainingSessionBooking = () => {
        if (data.redirectStatus !== 'succeeded') {
            return;
        }
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/training/slots`,
            method: 'put',
            data: { id: paymentDetail?._id, sessionSlots: bookedSlots }
        }).then((res) => {
            navigate('/Training');
            back(8);
        });
    };
useEffect(()=>{
    const da=JSON.parse(authStorage.getItem('payData'));
    const amou=authStorage.getItem('amountt');
    if(amou){
        setAmoun(amou)
    }
    if(da){
        // console.log("-----",da,"-",da?.receiptUrl,":::::",da?.invoiceDownloadUrl);
        setPaymentDetail(da?.data);
        setReceiptGloUrl(da?.receiptUrl);setInvoiceDownloadUrl(da?.invoiceDownloadUrl)
    }
},[])
    const addSlots = () => {
        if (bookedSlots.length >= paymentDetail?.sessions) {
            return;
        }
        let slots = [...bookedSlots];
        slots.push({ date: selectedFullDate, time: { startTime: selectedSlots?.startTime, endTime: selectedSlots?.endTime }, id: selectedSlots?._id });
        setBookedSlots(slots);
        setSelectedDay('');
    };

    const removeSlots = (slotToRemove) => {
        let slots = [...bookedSlots];
        bookedSlots.map((data, i) => {
            if (data?.date === slotToRemove.date && data.time === slotToRemove.time) {
                slots.splice(i, 1);
            }
        });
        setBookedSlots(slots);
    };

    useEffect(() => {
		
		console.log('data: ', data);
		
        createTrainningSession();
    }, [data]);

    useEffect(() => {
        if (!selectedFullDate) {
            return;
        }
        setLoading(true);
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            },
            url: `${BASE_URL}/user/training/available/session/${selectedFullDate}`, //your url
            method: 'get',
            data: { id: paymentDetail?._id, sessionSlots: bookedSlots }
        }).then((res) => {
            setAvailavleSlots(res?.data?.data)
            setLoading(false);
        });
    }, [currentDay]);

    const onClickDate = (day, currentFullDate) => {
        if (moment(currentFullDate).isBefore(moment())) {
            setError('Please Select Future Dates');
            setTimeout(() => {
                setError('');
            }, 3000);
            return;
        }
        setSelectedDay(day);
        setSelectedFullDate(currentFullDate);
    };



    const downloadReceipt = async (receiptUrl) => {
        receiptUrl=`${BASE_URL}${receiptUrl}`
        window.open(receiptUrl, '_blank')
    };
    const handleDownload = async (invoiceDownloadUrl) => {
        try {
          invoiceDownloadUrl = invoiceDownloadUrl.replace('http:', 'https:');
          console.log(invoiceDownloadUrl);
          
          const response = await fetch(invoiceDownloadUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'text/html',
            },
          });
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'invoice.html'); // You can set a dynamic name based on the response
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('There has been a problem with your fetch operation:', error);
        }
      };

    return (
        <div className="min-h-screen md:mx-10 md:h-auto mt-5">
            <div className="justify-center mb-8 p-4 md:p-6 bg-white rounded-lg">
                <div>
                    <div className="text-gray-900 text-2xl font-medium text-center mb-4">
                        <svg viewBox="0 0 24 24" className="text-blue-600 w-10 h-10 mx-auto mb-2 block">
                            <path fill="currentColor"
                                d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z">
                            </path>
                        </svg>
                        {/* ${paymentDetail?.amount / 100} PAYMENT DONE ! */}
                        ${amoun } PAYMENT DONE !
                    </div>
                    <div className="flex justify-center">
                        <div className="flex justify-center">
                            <a target="_blank" href={`${receiptGloUrl}`} className="flex justify-center rounded-lg mx-2 w-52 no-underline text-white py-2 bg-[#E53E14]" rel="noreferrer">
                                View Invoice
                            </a>
                        </div>
                        <div className="flex justify-center" >
                        {/* <a href={`${invoiceDownloadUrl}`} target="_blank" className="flex justify-center rounded-lg mx-2 w-52 py-2 no-underline text-[#E53E14] border border-solid border-[#E53E14]"  download>Download Invoice</a> */}
                       {/* <a target="_blank" href={`${invoiceDownloadUrl}`} className="flex justify-center rounded-lg mx-2 w-52 py-2 no-underline text-[#E53E14] border border-solid border-[#E53E14]"rel="noopener noreferrer">
                                Download Invoice
                            </a> */}
                            <button  onClick={() => handleDownload(invoiceDownloadUrl)} className="mx-2 inline-flex w-[200px] items-center justify-center bg-white rounded py-2 px-4 text-[#E53E14] hover:text-opacity-100 border border-solid border-[#E53E14]">
                            Download Invoice
                            </button>
                        </div>
                    </div>
                    <div className="text-gray-600 text-2xl font-medium text-center py-4">You have booked {paymentDetail?.sessionType} training session. Please select your slot below</div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row justify-center md:gap-0 gap-4 md:mx-0 mx-2">
                {currentDay ? (
                    <div className="md:w-[60%] bg-white pt-6 rounded-lg">
                        <div className="flex justify-center text-gray-900 mb-5">Please Select Slot - {moment(selectedFullDate).format('DD MMM YYYY')}</div>
                        <div className="flex justify-center flex-wrap text-gray-400">
                            {!loading &&
                                (availavleSlots?.length > 0) ?
                                (
                                    availavleSlots.map(data => (
                                        <div key={data?.startTime} onClick={() => setSelectedSlots(data)} className={`text-sm text-black false p-2 m-1 cursor-pointer bg-[#FFF5F3] ${(selectedSlots?.startTime === data?.startTime) && ' border bg-[#ff867a] '} p-2 m-1 cursor-pointer`}>
                                            {data.startTime} - {data.endTime}
                                        </div>
                                    ))
                                ) : (
                                    <div className="my-10">
                                        No Slots Available, Please select Another Date
                                    </div>
                                )
                            }
                        </div>

                        <div className="flex justify-center py-4">
                            <button disabled={(bookedSlots.length >= paymentDetail?.sessions)} id="submit" onClick={() => addSlots()} type="submit" className={`${(bookedSlots.length >= paymentDetail?.sessions) && ' cursor-not-allowed '} mx-2 inline-flex w-[200px] items-center bg-[#E53E14] justify-center rounded py-2 px-4 text-white hover:text-opacity-100 border border-solid border-[#E53E14]`}>
                                Book
                            </button>
                            <button onClick={() => setSelectedDay('')} className="mx-2 inline-flex w-[200px] items-center justify-center bg-white rounded py-2 px-4 text-[#E53E14] hover:text-opacity-100 border border-solid border-[#E53E14]">
                                Back
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="md:w-[60%] bg-white">
                        <div className="flex justify-center bg-white p-4">
                            <div className="flex justify-between my-4 w-3/4 text-black bg-gray">
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handlePreviousYear}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                                        />
                                    </svg>
                                </button>
                                <div
                                    className="text-md uppercase font-medium"
                                    style={{ marginTop: "5px" }}
                                >
                                    {currentYear}
                                </div>
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handleNextYear}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="flex justify-between my-4 w-3/4 text-black bg-gray">
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handlePreviousMonth}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                                        />
                                    </svg>
                                </button>
                                <div
                                    className="text-md w-14 flex justify-center uppercase font-medium"
                                    style={{ marginTop: "5px" }}
                                >
                                    {getMonthName(currentMonth)}
                                </div>
                                <button
                                    className="text-black px-4 py-2 rounded bg-white border-0"
                                    onClick={handleNextMonth}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="#A8AAAD"
                                        className="w-5 h-5"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="flex flex-wrap mt-2 p-4">
                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                <div
                                    key={day}
                                    className="w-[14.1867%] text-black text-center font-medium mb-2 bg-[#FFF5F3] p-3"
                                >
                                    {day}
                                </div>
                            ))}
                            {days.map((day, index) => {
                                let currentFullDate = `${currentYear}-${currentMonth?.toString().padStart(2, "0")}-${day?.toString().padStart(2, "0")}`;

                                let isCurrentDate =
                                    day === new Date().getDate() &&
                                    currentMonth === new Date().getMonth() + 1 &&
                                    currentYear === new Date().getFullYear();

                                return (
                                        <div
                                            onClick={() => onClickDate(day, currentFullDate)}
                                            key={index}
                                            className={`w-[14.1867%] ${day && 'cursor-pointer'} text-sm text-black border border-theme-blue text-center ${(currentDay === day) ? "bg-white" : "bg-white"}`}
                                        >
                                            <div className="p-4 md:py-2">
                                                <div className="flex justify-center">
                                                    <div
                                                        className={`${isCurrentDate
                                                            ? "text-[#2995F7]"
                                                            : "text-600"
                                                            } rounded w-6`}
                                                    >
                                                        {day}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                );
                            })}
                        </div>
                        <div className={`py-4 text-${error ? 'red-500' : 'black'} bg-[#F3F3F3] py-3 text-sm text-center`}>{error ? error : 'Please Select Date'}</div>
                    </div>
                )}
                <div className="md:ml-10 ml-0 md:w-[40%] bg-white p-4 text-black rounded-lg">
                    <div className="flex justify-center my-2">Booked Slots</div>
                    <div className="h-64 overflow-y-scroll">
                        {bookedSlots?.map(data => (
                            <div className="flex justify-between p-4 bg-slate-50 my-3 rounded-sm">
                                <div className="pr-4">{moment(data.date).format('DD MMM YYYY')} {data.time?.startTime} - {data.time?.endTime}</div>
                                <div className="cursor-pointer" onClick={() => removeSlots(data)}>
                                    <svg className="cursor-pointer h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex justify-center py-8">
                <button onClick={() => confirmTrainingSessionBooking()} type="submit" className="mx-2 inline-flex w-[200px] items-center justify-center bg-[#E53E14] border-1 border-white p-3 text-white hover:text-opacity-100 rounded-lg">
                    Confirm Booking
                </button>
               
                 <button onClick={() =>  {navigate('/Training'); back(8)}} className="mx-2 inline-flex w-[200px] items-center justify-center bg-white rounded py-2 px-4 text-[#E53E14] hover:text-opacity-100 border border-solid border-[#E53E14]">
                                Back
                            </button>
                
            </div>
        </div >
    );
}

export default PaymentConfirmationPage;
